import "./link-ticket-csv.styles.scss";
import { useState, useRef, useEffect } from "react";
import Button from "../button/button.component";
import CopyableListSection from "./copyable-list-section.component";

const LinkTicketCsv = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [showCsvInfo, setShowCsvInfo] = useState(false);
  const dropdownRef = useRef(null);

  const assetTypes = [
    "Chromebook", "Desktop", "Game Console", "iPad", "Laptop",
    "MacBook", "Phone", "Tablet"
  ];

  const problemTypes = [
    "Broken Glass", "Broken LCD", "Button", "Camera", "Charging", "Cosmetic", "Diagnostics",
    "Frame/Assembly/Case Damage", "Headphone Jack", "Keyboard", "Key Replacement/Repair",
    "Microphone", "No Power", "Other", "Rework", "Software", "Solder",
    "Speaker", "Touch", "Touchpad"
  ];

  const handleDownload = (fileType) => {

    const fileUrl =
      fileType === "csv"
        ? "/templates/ticket-upload-template.csv"
        : "/templates/ticket-upload-template.xlsx";

    const fileName =
      fileType === "csv"
        ? "Ticket Upload Template - Ticket template.csv"
        : "Ticket Upload Template - Ticket template.xlsx";

    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setIsDropdownOpen(false);

    if (fileType === "csv") {
      setShowCsvInfo(true); // Show info dialog
    }
  };

  const toggleDropdown = () => {
    const nextState = !isDropdownOpen;
    setIsDropdownOpen(nextState);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);

  return (
    <div className="link-ticket-csv" ref={dropdownRef}>
      <Button label="Ticket Template" onClick={toggleDropdown} />
      {isDropdownOpen && (
        <ul className={`dropdown-menu ${isDropdownOpen ? "open" : ""}`}>
          <li><a href="https://docs.google.com/spreadsheets/d/1YKikeqO_MU8f7yyfZ2CV3jPYrLVJJpgk85b16oeuovo/edit?gid=0#gid=0" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "inherit" }}>Google Sheet</a></li>
          <li onClick={() => handleDownload("excel")}>Excel</li>
          {/* <li onClick={() => handleDownload("csv")}>CSV</li> */}
      </ul>
      )}

      {/* Info Modal */}
      {showCsvInfo && (
        <div className="csv-info-modal-overlay">
        <div className="csv-info-modal">
          <button
            className="close-cross-btn"
            aria-label="Close modal"
            onClick={() => setShowCsvInfo(false)}
          >
            &times;
          </button>
      
          <h3>CSV Template Usage Guidance</h3>
          <p>Bulk upload requires a CSV with exact values for <strong>Asset Type (Column D)</strong> and <strong>Problem Type (Column F)</strong>. Please use the values provided below when utilizing the CSV Template to create your Bulk Upload File.</p>
            <p> ⚠️ Please note these values are case-sensitive and must be entered exactly as shown.</p>
            <CopyableListSection title="Asset Types" items={assetTypes} />
            <CopyableListSection title="Problem Types" items={problemTypes} />

            <p>Tickets with the incorrect Asset Type or Problem Type will fail the ticket creation process.</p>
            <button onClick={() => setShowCsvInfo(false)} className="close-info-btn">Got it</button>
        </div>
      </div>
      )}
    </div>
  );
};

export default LinkTicketCsv;
